export default __webpack_public_path__ + "static/media/close.ea7c95d7.svg";